/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// react-router-dom components
import { Link, useLocation, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useMediaQuery } from "react-responsive";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/backgroundLogin.png";
import bgImageMobile from "assets/images/backgroundLoginMobile.png";
import singhCoinBrand from "assets/images/singhCoinBrand.png";
import googleLoginLogo from "assets/images/googleLoginLogo.png";
import MDAvatar from "components/MDAvatar";

import validations from "customValidations/validations";
import validationService from "customValidations/validationService";
import { signIn } from "services/userService";
import { Divider, IconButton, InputAdornment, TextField } from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { GoogleLogin } from "react-google-login";
import { validateOtp } from "services/userService";

function Verify() {
  const navigate = useNavigate();
  const location = useLocation();

  const { email } = location.state;

  const [verificationCode, setVerificationCode] = useState("");

  const [errorMsg, setErrorMsg] = useState({
    verificationCode: { errorMsg: "" },
  });

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const customValidations = (name, value) => {
    let errorLength = 0;
    const args = [
      {
        name,
        value: value,
        validations: validations.signInValidations[name],
      },
    ];

    validationService.validate(args, (validationErr, validationErrMsgs) => {
      if (validationErrMsgs.length > 0) {
        errorLength = errorLength + 1;
        errorMsg[name].errorMsg = validationErrMsgs[0].validations[0].message;
        setErrorMsg({ ...errorMsg });
      } else {
        errorMsg[name].errorMsg = "";
        setErrorMsg({ ...errorMsg });
      }
    });
    return errorLength;
  };

  const handleInputChange = (name, value) => {
    if (name === "verificationCode") {
      setVerificationCode(value);
    } else {
      console.log("IputError");
    }
  };

  const handleVerify = async () => {
    let errorLengthVerificationCode = customValidations(
      "verificationCode",
      verificationCode
    );

    if (errorLengthVerificationCode === 1) {
      console.log("Validation error");
      return;
    }

    const verificationData = {
      email: email,
      otp: verificationCode,
    };

    const validateOtpRes = await validateOtp(verificationData);
    console.log("validateOtpRes", validateOtpRes);

    if (validateOtpRes.status === 200) {
      navigate("/reset-password", { state: { email } });
    }
  };

  return (
    <BasicLayout image={isDesktopOrLaptop ? bgImage : bgImageMobile}>
      <Card sx={{ backgroundColor: "#ebebeb", boxShadow: "none" }}>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox
            sx={{
              marginBottom: "2rem",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <MDAvatar
              src={singhCoinBrand}
              sx={{ height: "100px", width: "100px" }}
            />
          </MDBox>
          <MDBox sx={{ textAlign: "center", marginBottom: "1rem" }}>
            <MDTypography
              fontWeight="bold"
              color="text"
              sx={{ lineHeight: "20px" }}
            >
              Verification code has been sent to your registered email
            </MDTypography>
          </MDBox>
          <MDBox role="form">
            <MDBox mb={2}>
              <TextField
                fullWidth
                // type="email"
                name="verificationCode"
                label="Verificationcode"
                inputProps={{
                  style: { color: "#000000" },
                }}
                error={errorMsg.verificationCode.errorMsg.length > 0}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
                helperText={errorMsg.verificationCode.errorMsg}
              />
            </MDBox>
            <MDBox>
              <MDButton fullWidth color="singh" onClick={handleVerify}>
                Verify
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Verify;
